import DatabaseModel from './DatabaseModelOffline.js';

var Plantilla = Object.create(DatabaseModel);

Plantilla.model = 'plantillas';

export default Plantilla;